import logo from '../img/logo.png';
import React, { useEffect, useState } from 'react'
import { db, firebaseAuth, storage } from "../utils/firebase-config";
import { createUserWithEmailAndPassword, onAuthStateChanged, signOut } from "firebase/auth";
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { doc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import HomeLf from './HomeLf';
import './register.css';



import cadastropeople from "../assets/version2/cadastropeople.png";
import cadastrodetalhe from "../assets/version2/cadastrodetalhe.png";
import cadastroarroba from "../assets/version2/cadastroarroba.png";
import Privacidade from './Privacidade';



//import Header from './Header';

// REGISTER MASTER

function Register() {

    const navigate = useNavigate();






    if(window.location.href.slice(window.location.href.length - 1, window.location.href.length) != '/') {
      document.querySelector('.oisumida').style.display = 'none';
  } else {
  
      document.querySelector('.oisumida').style.display = 'block';
      
  }










    const [deslogado, setDeslogado] = useState(false);



    
    const [stepby, setStepby] = useState('none')
    const [page01, setPage01] = useState('block');
    const [page02, setPage02] = useState('none');
    const [page03, setPage03] = useState('none');
    const [page04, setPage04] = useState('none');
    const [page05, setPage05] = useState('none');
    const [page06, setPage06] = useState('none');
    const [page07, setPage07] = useState('none');



    const [emaill, setEmaill] = useState('');
    const [senha, setSenha] = useState('');
    const [senhaCnf, setSenhaCnf] = useState('');
    const [nome, setNome] = useState('');
    const [empresa, setEmpresa] = useState('');
    const [politica, setPolitica] = useState(false);
    const [termos, setTermos] = useState(false);


    const [imageUpload, setImageUpload] = useState();
    const [imageUpload2, setImageUpload2] = useState();
    const [imageUpload3, setImageUpload3] = useState();
    const [imageUpload4, setImageUpload4] = useState();
    const [videoUpload, setVideoUpload] = useState();


    const [ativo, setAtivo] = useState(true);



    const [url01, setUrl01] = useState('');
    const [url02, setUrl02] = useState('');
    const [url03, setUrl03] = useState('');
    const [url04, setUrl04] = useState('');
    const [url05, setUrl05] = useState('');

    const [msgs, setMsgS] = useState('');
    const [msgs2, setMsgS2] = useState('');
    const [msgs3, setMsgS3] = useState('');
    const [msgs4, setMsgS4] = useState('');
    const [msgs5, setMsgS5] = useState('');
    const [msgs6, setMsgS6] = useState('');


















    async function finishMaster(params) {




      if(termos == false) {alert('Você deve concordar com os termos de uso!'); return }
      if(politica == false) {alert('Você deve concordar com nossa política de privacidade!'); return }
            const dataAtual2 = new Date();        
            var data55 = dataAtual2.toISOString();
    

      await createUserWithEmailAndPassword(firebaseAuth, emaill, senha);



      
        
        await setDoc(doc(db, 'clientes', `${emaill}`), {
            nome: nome,
            empresa: empresa,
            email: emaill,
            admin: false,
            criacao: data55,
            colaboradores: [],
            notificacoes: [],
            disciplinas: []

          });
         
          
          setTimeout(() => {
            navigate('/');
          }, 1000);

    }

 




   async function enviarImagensVideo(params) {

            finishMaster();
            
        
    }





    const uploadFile = async (params) => {
        if (!params) return;
      

        const imageRef = ref(storage, `clientesMidias/${emaill}/${'foto01'}`);

        uploadBytes(imageRef, params).then((snapshot) => {
            getDownloadURL(snapshot.ref).then((url) => {
                setUrl01(url);
       
            });
        }  );

    };

  
    const uploadFile2 = (params) => {
        if (!params) return;
    

        const imageRef = ref(storage, `clientesMidias/${emaill}/${'foto02'}`);

        uploadBytes(imageRef, params).then((snapshot) => {
            getDownloadURL(snapshot.ref).then((url) => {
                setUrl02(url);
            });
        }  );

    };


    const uploadFile3 = (params) => {
        if (!params) return;
      

        const imageRef = ref(storage, `clientesMidias/${emaill}/${'foto03'}`);

        uploadBytes(imageRef, params).then((snapshot) => {
            getDownloadURL(snapshot.ref).then((url) => {
                setUrl03(url);
            });
        }  );

    };


    const uploadFile4 = (params) => {
        if (!params) return;
     

        const imageRef = ref(storage, `clientesMidias/${emaill}/${'foto04'}`);

        uploadBytes(imageRef, params).then((snapshot) => {
            getDownloadURL(snapshot.ref).then((url) => {
                setUrl04(url);
            });
        }  );

    };

    const uploadFile5 = (params) => {
        if (!params) return;
        setVideoUpload(params);

        const imageRef = ref(storage, `clientesMidias/${emaill}/${params.name}`);

        uploadBytes(imageRef, params).then((snapshot) => {
            getDownloadURL(snapshot.ref).then((url) => {
                setUrl05(url);
            });
        }  );

    };








    const [logado, setLogado] = useState(false);


    function logOut(params) {
      signOut(firebaseAuth); 
      setLogado(false);
    }

    function master(params) {
        

    onAuthStateChanged(firebaseAuth, async (currentUser) => {
        if (currentUser) {setLogado(true);
        
     
    }
      });
    }


  return (
  
<>



  
  



























































<div className="row" style={{display: 'flex', justifyContent: 'center'}}>
  <div className="col-md-2 col-sm-12 flex-column align-items-end sumir"></div>
  <div
    className="col-md-4 col-sm-12 vocedevolta d-flex flex-column align-items-md-start align-items-sm-center"
    style={{ paddingTop: 120 }}
  >
    Solicite acesso
    <br /> ao Lumera 3D
    <div className="seespaco">
      {" "}
      <br />
      Cadastre-se e nossa equipe entrará em contato
      <br /> com você.
    </div>
    <img
      style={{ marginTop: 40, width: 50, height: 50 }}
      src={cadastropeople}
    />
  </div>
  <div
    className="col-md-4 col-sm-12 titulosCadastro d-flex flex-column cardlogin align-items-sm-center align-items-md-center"
    style={{ paddingTop: 100 }}
  >
    <div
      className="quadradologin row row-cols-1"
      style={{ alignItems: "center", paddingTop: 60, justifyContent: "center", height: '900px'}}
    >
      <div
        className="col-10"
        style={{
          display: "column",
          justifyContent: "center",
          marginTop: "-40px",
          color: "#424856"
        }}
      >
        Nome completo
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            border: "solid #BDC1CA 1px",
            paddingLeft: 10,
            paddingRight: 140,
            paddingTop: 2,
            paddingBottom: 2,
            borderRadius: 6,
            marginBottom: 14
          }}
          onChange={(e) => setNome(e.target.value)  }
        >
          {" "}
          <input
            className="inputLogin fontLoginInputPlace"
            style={{ border: "none", height: 43, width: 345 }}
            placeholder="Insira seu nome e sobrenome"
            type="text"
          />{" "}
        </div>
        Empresa
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            border: "solid #BDC1CA 1px",
            paddingLeft: 10,
            paddingRight: 140,
            paddingTop: 2,
            paddingBottom: 2,
            borderRadius: 6,
            marginBottom: 14
          }}
        >
          {" "}
          <input
            className="inputLogin fontLoginInputPlace"
            style={{ border: "none", height: 43, width: 345 }}
            placeholder="Insira o nome da sua empresa"
            type="text"
            onChange={(e)=> setEmpresa(e.target.value)}
          />{" "}
        </div>
        Email profissional
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            border: "solid #BDC1CA 1px",
            paddingLeft: 10,
            paddingRight: 140,
            paddingTop: 2,
            paddingBottom: 2,
            borderRadius: 6,
            marginBottom: 16
          }}
        >
          {" "}
          <input
            className="inputLogin fontLoginInputPlace"
            style={{ border: "none", height: 43, width: 345 }}
            placeholder="seuemail@empresa.com"
            type="text"
            onChange={(e) => setEmaill(e.target.value)  }
          />{" "}
        </div>
        <div
          style={{
            height: 80,
            width: "100%",
            backgroundColor: "#197dca21",
            marginBottom: 12
          }}
        >
          <img src={cadastrodetalhe} />{" "}
          <a style={{ fontWeight: 400, fontSize: 14 }}>
            Use seu e-mail corporativo para convidar membros de sua equipe.
          </a>
        </div>
        Senha
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            border: "solid #BDC1CA 1px",
            paddingLeft: 10,
            paddingRight: 140,
            paddingTop: 2,
            paddingBottom: 2,
            borderRadius: 6,
            marginBottom: 14
          }}
        >
          {" "}
          <input
            className="inputLogin fontLoginInputPlace"
            style={{ border: "none", height: 43, width: 345 }}
            placeholder="Insira uma senha forte"
            type="password"
            onChange={(e) => setSenha(e.target.value)  }
          />{" "}
        </div>
        Repetir Senha
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            border: "solid #BDC1CA 1px",
            paddingLeft: 10,
            paddingRight: 140,
            paddingTop: 2,
            paddingBottom: 2,
            borderRadius: 6,
            marginBottom: 25
          }}
        >
          {" "}
          <input
            className="inputLogin fontLoginInputPlace"
            style={{ border: "none", height: 43, width: 345 }}
            placeholder="Repita a senha"
            type="password"
            onChange={(e)=> setSenhaCnf(e.target.value) }
          />{" "}
        </div>
        <div
          className="fontLoginFoget"
          style={{ marginLeft: 2, marginBottom: 14 }}
        >
          {" "}
          <input type="checkbox" style={{ marginRight: 6 }} 
          onChange={(e)=> setTermos(e.target.checked)}
          />
          Li e concordo com os <a style={{cursor: 'pointer'}} onClick={()=> navigate('/termosdeuso')}>Termos de Uso.</a>
        </div>
        <div
          className="fontLoginFoget"
          style={{ marginLeft: 2, marginBottom: 30 }}
        >
          {" "}
          <input type="checkbox" style={{ marginRight: 6 }} 
           onChange={(e)=> setPolitica(e.target.checked)}
          />
          Li e concordo com a <a style={{cursor: 'pointer'}} onClick={()=> navigate('/termosdeuso')}>Política de Privacidade.</a>
        </div>
      </div>
      <div className="col-10" style={{ marginTop: "-40px", marginBottom: 24 }}>
        <button className="botaoLogin"
          onClick={()=> finishMaster()}
        >Cadastrar</button>
      </div>
      <div
        className="col-10"
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "-60px"
        }}
      >
        <div className="fontLoginFoget" style={{ marginRight: 22 }}>
          {" "}
          Já possui conta na Lumera 3D?
        </div>
        <a className="loginEsqueciSenha" style={{ fontSize: 14, cursor: 'pointer' }}
        onClick={()=> navigate('/login')}
        >
          Log in
        </a>
      </div>
      <a
        style={{
          fontWeight: 300,
          fontSize: 12,
          textAlign: "center",
          marginBottom: "-14px"
        }}
      >
        © 2025 Lumera 3D - Uma marca Kollabity Engineering Data
      </a>
    </div>
  </div>
  <div
    className="col-md-2 col-sm-12"
    style={{ paddingTop: 260, paddingLeft: 80 }}
  >
    <img src={cadastroarroba} />
  </div>
</div>














<div style={{width: '100%', height: '100px', color: 'transparent'}}>Lumera3d</div>

































  





 








      



        <div class="card card-1" style={{marginTop: '-100px', display: page06}}>
            <div class="card-heading"></div>
            <div class="card-body">
                <h2 class="title">Fotos</h2>
           
                    <div class="input-group" style={{width: '400px'}} >
                  <a>Foto 1 (Perfil)</a>  <input
   type="file"
   onChange={(event) => {
    setImageUpload(event.target.files[0]);
    uploadFile(event.target.files[0]);
   }}
   />
                    </div>

{
    url01.length > 2 ?
    
    <div class="input-group" style={{width: '400px'}} >
    <a>Foto 2</a>  <input
type="file"
onChange={(event) => {
uploadFile2(event.target.files[0]);
}}
/>
      </div>

: ''
}

                   
            
{
  url02.length > 2 ?
  <div class="input-group" style={{width: '400px'}} >
                  <a>Foto 3</a>  <input
   type="file"
   onChange={(event) => {
    uploadFile3(event.target.files[0]);
   }}
   />
                    </div>

  : ''
}
                    
                  


{
    url03.length > 2 ?

    <div class="input-group" style={{width: '400px'}} >
    <a>Foto 4</a>  <input
type="file"
onChange={(event) => {
uploadFile4(event.target.files[0]);
}}
/>
      </div>

    : ''
}

                  




                 







                    <div class="row row-space col-4">
                        
                 
        {url01.length > 2 ?
         <button class="btn button"
         style={{minWidth: '200px', color: 'white', backgroundColor: '#4646D6'}}
         type="submit"
         onClick={()=> finishMaster()}
         >Continuar</button> 
    :
    <button disabled class="btn button"
    type="submit"
    style={{minWidth: '200px', backgroundColor: '#4646D6'}}
    >Continuar</button>

    }
                      
                      
                    </div>

            
            </div>
        </div>


        <div class="card card-1" style={{marginTop: '-100px', display: page07}}>
            <div class="card-heading"></div>
            <div class="card-body">
                <h2 class="title">Fotos</h2>
           
                    <div class="input-group" style={{width: '400px'}} >
                  <a>Foto 1 (Perfil)</a>  <input
   type="file"
   onChange={(event) => {
    setImageUpload(event.target.files[0]);
   }}
   />
                    </div>

                    <div class="input-group" style={{width: '400px'}} >
                  <a>Foto 2</a>  <input
   type="file"
   onChange={(event) => {
    setImageUpload2(event.target.files[0]);
   }}
   />
                    </div>
            

                    
                    <div class="input-group" style={{width: '400px'}} >
                  <a>Foto 3</a>  <input
   type="file"
   onChange={(event) => {
    setImageUpload3(event.target.files[0]);
   }}
   />
                    </div>





                    <div class="input-group" style={{width: '400px'}} >
                  <a>Foto 4</a>  <input
   type="file"
   onChange={(event) => {
    setImageUpload4(event.target.files[0]);
   }}
   />
                    </div>





            







                    <div class="row row-space col-4">
                        
                 

                        <button class="btn button"
                         type="submit"
                         style={{ color: 'white', backgroundColor: '#4646D6'}}
                         onClick={()=> enviarImagensVideo()}
                         >Finalizar Cadastro</button>

                      
                      
                    </div>

            
            </div>

        </div>

        </>
  );
}

export default Register;







